export const FB_PIXEL_ID = '468429509606728';

export const pageview = () => {
  if (window.fbq) {
    window.fbq('track', 'PageView');
  }
};

export const event = (name, options = {}) => {
  if (window.fbq) {
    window.fbq('track', name, options);
  }
};

export const FACEBOOK_EVENTS = {
  REGISTRATION_START: 'StartRegistration',
  REGISTRATION_COMPLETE: 'CompleteRegistration',
  LEAD: 'Lead',
  CONTEST_ENTRY: 'ContestEntry',
  MARKETING_CONSENT: 'MarketingConsent'
}; 